module.exports = __webpack_public_path__ + "static/media/resultats_bdl2022.c6ccd9f1.jpg";